import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 12157 17444"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970270476544">
        <path
          d="m220 11202 5193 5939c352 403 979 403 1331 0l5192-5939c500-572 94-1466-665-1466H886c-759 0-1165 894-666 1466zM10230 7535c0-345-280-625-625-625s-625 280-625 625 280 625 625 625 625-280 625-625zM7879 7535c0-345-280-625-625-625s-625 280-625 625 280 625 625 625 625-280 625-625z"
          className="fil0"
        />
        <circle
          r={3749}
          className="fil0"
          transform="matrix(0 .16656 -.16656 0 4902.93 7534.75)"
        />
        <path
          d="M3177 7535c0-345-280-625-625-625s-625 280-625 625 280 625 625 625 625-280 625-625zM10230 5232c0-345-280-625-625-625s-625 280-625 625 280 624 625 624 625-279 625-624zM7879 5232c0-345-280-625-625-625s-625 280-625 625 280 624 625 624 625-279 625-624zM5528 5232c0-345-280-625-625-625s-625 280-625 625 280 624 625 624 625-279 625-624zM3177 5232c0-345-280-625-625-625s-625 280-625 625 280 624 625 624 625-279 625-624zM7879 2928c0-345-280-625-625-625s-625 280-625 625 280 625 625 625 625-280 625-625zM5528 2928c0-345-280-625-625-625s-625 280-625 625 280 625 625 625 625-280 625-625zM7879 625c0-345-280-625-625-625s-625 280-625 625 280 625 625 625 625-280 625-625z"
          className="fil0"
        />
        <circle
          r={3749}
          className="fil0"
          transform="matrix(0 .16656 -.16656 0 4902.93 624.745)"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
